<template>
  <div>
    <b-row class="my-3">
      <b-col cols="4">
        <b-row v-if="getReservationTask != null">
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">#</th>
                    <th class="px-2 py-1">File Name</th>
                    <th class="px-2 py-1 float-end">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(file, idx) in getReservationTask.reservation.reservationAttachment" :key="idx" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{idx + 1}}</td>
                    <td class="px-2 py-1 text-capitalize">{{file.description}}</td>
                    <td class="px-2 py-1">
                      <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="8">
        <BusinessNameAttachments ref="attachmentScreen"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import server from "@/app/env/server.json";
import BusinessNameAttachments from "@/views/home/services/registration/task/BusinessNameAttachments";

export default {
  name: "ReservationFiles",
  components: {BusinessNameAttachments},
  data(){
    return{
      attachmentUrl:null
    }
  },
  mounted() {
    if (this.getReservationTask.reservation.reservationAttachment[0] !== undefined) {
      this.openFile(this.getReservationTask.reservation.reservationAttachment[0])
    }
  },
  methods:{
    ...mapActions(["fetchAddressByVillageId"]),
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    openFile(data){
      this.attachmentUrl = null;
      this.attachmentUrl = server.IP+"/reservation/attachment/"+data.filename
    },
    cleanName(name){
      let n = name.replaceAll("_", " ")
      return n.toLowerCase()
    },
  },
  computed:{
    ...mapGetters(["getReservationTask", "getAddress"])
  },
  watch:{
    getReservationTask(data){
      let file = data.reservation.reservationAttachment[0]
      this.openFile(file)
    },
    attachmentUrl:{
      handler(url){
        if (url !== null) {
          this.$refs.attachmentScreen.openFile(url)
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>

th, td{
  font-size: 12px;
}

</style>